import React from 'react';
import Icon from 'components/AppIcon';
import useReps from 'hooks/useReps';

const STATUS_OPTIONS = ['all', 'New', 'Contacted', 'Qualified', 'Unqualified', 'Won', 'Lost'];
const SOURCE_OPTIONS = ['all', 'Website', 'Referral', 'Event', 'Social Media', 'Cold Call', 'Import'];

export default function LeadsFilterPanel({ filters, onFiltersChange, onClose }) {
  const reps = useReps();
  const repOptions = ['all', ...(reps || []), 'Unassigned'];
  const handleChange = (key, value) => {
    onFiltersChange?.({ ...filters, [key]: value });
  };

  const hasActiveFilters = filters?.status !== 'all' || filters?.source !== 'all' || filters?.rep !== 'all';

  return (
    <div
      className="rounded-xl p-4"
      style={{ background: 'var(--color-card)', border: '1px solid var(--color-border)' }}
    >
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <Icon name="SlidersHorizontal" size={16} color="var(--color-primary)" />
          <span className="font-caption font-semibold text-sm" style={{ color: 'var(--color-foreground)' }}>
            Filters
          </span>
          {hasActiveFilters && (
            <span
              className="px-1.5 py-0.5 rounded-full font-caption text-xs font-medium"
              style={{ background: 'var(--color-primary)', color: '#fff' }}
            >
              Active
            </span>
          )}
        </div>
        <div className="flex items-center gap-2">
          {hasActiveFilters && (
            <button
              className="font-caption text-xs hover:underline"
              style={{ color: 'var(--color-error)' }}
              onClick={() => onFiltersChange?.({ status: 'all', source: 'all', rep: 'all' })}
            >
              Clear all
            </button>
          )}
          {onClose && (
            <button onClick={onClose} style={{ color: 'var(--color-text-secondary)' }}>
              <Icon name="X" size={14} color="currentColor" />
            </button>
          )}
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        {/* Status */}
        <div>
          <label className="block font-caption text-xs font-medium mb-1.5" style={{ color: 'var(--color-text-secondary)' }}>
            Status
          </label>
          <div className="flex flex-wrap gap-1.5">
            {STATUS_OPTIONS?.map((s) => (
              <button
                key={s}
                onClick={() => handleChange('status', s)}
                className="px-2.5 py-1 rounded-full font-caption text-xs font-medium transition-all duration-150"
                style={{
                  background: filters?.status === s ? 'var(--color-primary)' : 'var(--color-muted)',
                  color: filters?.status === s ? '#fff' : 'var(--color-text-secondary)',
                }}
              >
                {s === 'all' ? 'All' : s}
              </button>
            ))}
          </div>
        </div>

        {/* Source */}
        <div>
          <label className="block font-caption text-xs font-medium mb-1.5" style={{ color: 'var(--color-text-secondary)' }}>
            Lead Source
          </label>
          <select
            value={filters?.source || 'all'}
            onChange={(e) => handleChange('source', e?.target?.value)}
            className="w-full text-sm px-3 py-2 rounded-lg border font-caption"
            style={{ borderColor: 'var(--color-border)', background: 'var(--color-card)', color: 'var(--color-foreground)' }}
          >
            {SOURCE_OPTIONS?.map((s) => (
              <option key={s} value={s}>{s === 'all' ? 'All Sources' : s}</option>
            ))}
          </select>
        </div>

        {/* Rep */}
        <div>
          <label className="block font-caption text-xs font-medium mb-1.5" style={{ color: 'var(--color-text-secondary)' }}>
            Assigned Rep
          </label>
          <select
            value={filters?.rep || 'all'}
            onChange={(e) => handleChange('rep', e?.target?.value)}
            className="w-full text-sm px-3 py-2 rounded-lg border font-caption"
            style={{ borderColor: 'var(--color-border)', background: 'var(--color-card)', color: 'var(--color-foreground)' }}
          >
            {repOptions?.map((r) => (
              <option key={r} value={r}>{r === 'all' ? 'All Reps' : r}</option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
}
